import AccountPartial from "../../partials/account/account.partial";
export default function AccountScreen() {
  return <AccountPartial />;
}
